import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import { ReactNode } from "react";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";

type UiCardVariant = "panel" | "section" | "inner" | "info" | "summary" | "modal-section";

type UiCardProps = {
  variant?: UiCardVariant;
  children: ReactNode;
  sx?: Record<string, unknown>;
  className?: string;
};

const panelCardSx = {
  width: "100%",
  borderRadius: "12px",
  border: `1px solid ${draftColors.borderSoft}`,
  backgroundColor: draftColors.surface,
  boxShadow: draftColors.shadow,
  overflow: "hidden",
};

const sectionCardSx = {
  borderRadius: "10px",
  border: `1px solid ${draftColors.border}`,
  backgroundColor: draftColors.surface,
  overflow: "hidden",
};

const innerCardSx = {
  borderRadius: "10px",
  border: `1px solid ${draftColors.border}`,
  backgroundColor: draftColors.surface,
  p: "8px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const infoCardSx = {
  borderRadius: "10px",
  border: `1px solid ${draftColors.border}`,
  backgroundColor: "#F9FAFC !important",
  p: "12px",
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const summaryCardSx = {
  borderRadius: "8px",
  backgroundColor: "#F9FAFC",
  border: `1px solid ${draftColors.border}`,
  p: "10px 12px",
};

const modalSectionCardSx = {
  border: `1px solid ${draftColors.border}`,
  borderRadius: "12px",
  backgroundColor: draftColors.surface,
  p: "14px",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const variantMap: Record<UiCardVariant, { useMuiCard: boolean; styles: Record<string, unknown> }> =
  {
    panel: { useMuiCard: true, styles: panelCardSx },
    section: { useMuiCard: false, styles: sectionCardSx },
    inner: { useMuiCard: false, styles: innerCardSx },
    info: { useMuiCard: false, styles: infoCardSx },
    summary: { useMuiCard: false, styles: summaryCardSx },
    "modal-section": { useMuiCard: false, styles: modalSectionCardSx },
  };

export default function UiCard({ variant = "section", children, sx, className }: UiCardProps) {
  const { useMuiCard, styles } = variantMap[variant];

  if (useMuiCard) {
    return (
      <Card className={className} sx={{ ...styles, ...sx }}>
        {children}
      </Card>
    );
  }

  return (
    <MDBox className={className} sx={{ ...styles, ...sx }}>
      {children}
    </MDBox>
  );
}
